
import {makeAutoObservable} from "mobx";

class AlertDialogState {
    constructor() {
        this.open = false;
        makeAutoObservable(this);
    }

    isOpen() {
        return this.open;
    }

    openDialog = () => {
        this.open = true;
    }

    closeDialog = () => {
        this.open = false;
    }
}

export default AlertDialogState
